import React, { Component } from 'react'
import ProfilePicture from 'components/profile/profile-picture'
import { connect } from 'react-redux'
import moment from 'moment'
import Loader from 'components/loader/loader'

import { Link } from 'react-router-dom'

import { forIn, filter, sortBy } from 'lodash'

import { 
	loadMore,
	getMissingEntities,
	getActivityForDay
} from 'state/actions'

import AlertBanner from 'components/alerts/alert-banner'
import LoadMore from 'components/load-more/load-more'

import { getCurrentAccount } from 'state/selectors'

import { 
	stripHtml,
	paragraphToLines,
	formatByTimeZone,
	doSort,
	modelTypeToString,
	ucfirst,
	formatStandardDateTime,
	getStatusName
} from 'utils'

class ActivityList extends Component {
	state = {
		isFetching: false, // used for 'load more'
		hasMore: false,
		activityListHeight: 0
	}

	isFetchingMissing = false // this is exempt from state
	activityRefs = {}
	currentOffset = 0
	missingEntitiesByType = {}

	groupedActivityGroups = []
	totalItems = 0

	
	UNSAFE_componentWillMount = _ => {
		this.generateGroupedActivityGroups()
	}

	UNSAFE_componentWillUpdate = nextProps => {
		if(this.props.entities && this.props.entities.activities){
			this.generateGroupedActivityGroups(nextProps)
		}
	}

	generateGroupedActivityGroups = (props = this.props) => {
		const{
			context,
			entities,
			currentAccount,
			projectId,
			team,
			user,
			selectedDate,
			selectedUserId
		} = props

		let groupedActivityGroups = []

		let activities = filter(entities.activities, activity => {
			let shouldInclude = false

			if(selectedUserId && selectedUserId !== activity.user_id){
				return false
			}

			switch(context){
				case 'account':
					shouldInclude = activity.account_id === currentAccount.id
					break
				case 'project':
					shouldInclude = activity.project_id === projectId

					if(selectedDate && shouldInclude){
						const createdMoment = moment(activity.created_at)
						shouldInclude = createdMoment.isSame(selectedDate, 'day')
					}
					break
				case 'team':
					let hasMatchingProjectId = false
					let hasMatchingUserId = false

					let hasRemovedTeamFromProject = activity.action == 'TEAM_REMOVED_FROM_PROJECT' && activity.new_data == team.id

					team.projectIds.forEach(projectId => {
						if(activity.project_id === projectId){
							hasMatchingProjectId = true
						}
					})

					team.userIds.forEach(userId => {
						if(activity.user_id === userId){
							hasMatchingUserId = true
						}
					})

					shouldInclude = (hasMatchingProjectId && hasMatchingUserId) || hasRemovedTeamFromProject
					break
				case 'user':
					shouldInclude = activity.user_id === user.id
					break
			}

			return shouldInclude
		})

		let lastLoopedActivityDay = ''

		this.currentOffset = activities.length

		// remove this after
		activities = sortBy(activities, activity => {
			return new Date(activity.created_at)
		})

		forIn(activities, activity => {
			if(!activity.activityable){
				return
			}

			const itemGroup = entities[activity.activityable.schema]

			if(!itemGroup){
				return
			}

			const activityable = itemGroup[activity.activityable_id]

			if (!activityable) {
				return 
			}

			// custom new_data, cause sometimes we can infer it from the activityable.
			let new_data = activity.new_data

			if(!activity.activityable || !activity.project_id){
				return 
			}

			const project = this.getProjectFromObject(activityable, modelTypeToString(activity.activityable_type))

			if(!project){
				return
			}

			switch(activity.action){
				case 'UPDATE_ORDER':
				case 'PROCESSED':
					return
				case 'CREATE':
					if(activity.activityable_type == 'App\\Session'){
						return
					}
					break
				case 'UPLOAD':
					if(activityable.task_id){
						new_data = 'task_'+activityable.task_id
					}else if(activityable.project_id){
						new_data = 'project_'+activityable.project_id
					}else{
						return
					}
					break
				case 'POST':
					new_data = activityable.task_id
					break
			}


			// At this point, we're pretty sure it's going to be rendered.
			let isDifferentDay = false
			const createdMoment = moment(activity.created_at)
			
			const activityDay = createdMoment.format('YYYY-MM-DD')

			if (activityDay != lastLoopedActivityDay) {
				isDifferentDay = true
			}

			lastLoopedActivityDay = activityDay

			if (isDifferentDay) {
				groupedActivityGroups.push({
					date: activity.created_at,
					groupedActivities: [
						{
							action: activity.action,
							type: activity.activityable_type,
							user_id: activity.user_id,
							project_id: activity.project_id,
							oldData: activity.old_data,
							data: new_data,
							activities: [
								activity
							]
						}
					]
				})
			} else {
				const groupedActivityGroupIndex = (groupedActivityGroups.length - 1)

				const lastGroupedActivityGroup = groupedActivityGroups[groupedActivityGroupIndex]

				const lastActivityGroup = lastGroupedActivityGroup.groupedActivities[0]
				const lastActivity = lastActivityGroup.activities[0]

				const currentActivityGroup = groupedActivityGroups[groupedActivityGroupIndex].groupedActivities

				let indexOfDuplicateAction = -1

				if(activity.activityable_type == 'App\\Note' && activity.action == 'UPDATE'){
					indexOfDuplicateAction = currentActivityGroup.findIndex(loopedActivity => {
						return loopedActivity.action == 'UPDATE' && loopedActivity.type == 'App\\Note' && loopedActivity.user_id == activity.user_id && loopedActivity.activityable_id === activity.activityable_id
					})
				}

				if(indexOfDuplicateAction > -1){
					groupedActivityGroups[groupedActivityGroupIndex].groupedActivities[indexOfDuplicateAction].activities = [activity]
				}else if (activity.action == lastActivityGroup.action && activity.user_id === lastActivityGroup.user_id && activity.activityable_type === lastActivityGroup.type && new_data === lastActivityGroup.data && lastActivityGroup.project_id === activity.project_id) {
					const objectType = modelTypeToString(lastActivityGroup.type) + 's'

					const activityable = entities[objectType][activity.activityable_id]
					const lastActivityable = entities[objectType][lastActivity.activityable_id]

					if (activityable.id != lastActivityable.id) {
						groupedActivityGroups[groupedActivityGroupIndex].groupedActivities[0].activities.unshift(activity)
					}
				} else {
					groupedActivityGroups[groupedActivityGroupIndex].groupedActivities.unshift({
						action: activity.action,
						type: activity.activityable_type,
						user_id: activity.user_id,
						project_id: activity.project_id,
						oldData: activity.old_data,
						data: new_data,
						activities: [
							activity
						]
					})
				}
			}
		})

		this.groupedActivityGroups = groupedActivityGroups
		this.totalItems = activities.length
	}

	getObjectName = (object, schema) => {
		let name = ''
		
		const {
			entities
		} = this.props

		switch (schema) {
			case 'comments':
				name = stripHtml(object.text)
				break
			case 'notes':
				const allLines = paragraphToLines(object.text)

				name = ''

				allLines && allLines.some(line => {
					if(line){
						name = line

						return true
					}
				})

				if(!name){
					name = 'an empty note'
				}
				break
			case 'sessions':
				const task = entities.tasks[object.task_id]

				name = task ? task.name : ''
				break
			case 'users':
				name = 'their profile'
				break
			case 'teams':
				name = 'this team'

				const teamId = parseInt(object)

				if(entities.teams && entities.teams[teamId]){
					name = '<strong>'+entities.teams[teamId].name+'</strong>'
				}
				break
			default:
				name = object ? object.name : ''
				break
		}

		return name
	}

	componentDidMount = _ => {
		this.recalculateHeight()
	}

	componentDidUpdate = prevProps => {
		this.recalculateHeight()

		if(Object.keys(this.missingEntitiesByType).length && !this.isFetchingMissing){
			// get missing entities here!
			this.isFetchingMissing = true

			this.props.getMissingEntities(this.missingEntitiesByType, _ => {
				this.isFetchingMissing = false
			})
		}

		const {
			isPulse
		} = this.props

		if(isPulse && this.props.selectedDate.format('YYYY-MM-DD') !== prevProps.selectedDate.format('YYYY-MM-DD') && !this.groupedActivityGroups.length){
			this.getActivityForDay(this.props.selectedDate)
		}
	}

	recalculateHeight = _ => {
		window.requestAnimationFrame(_ => {
			if(!this.activityRefs.inner){
				return
			}

			const activityListHeight = this.activityRefs.inner.getBoundingClientRect().height

			if(activityListHeight !== this.state.activityListHeight){
				this.setState({
					activityListHeight
				})
			}
		})
	}

	getActivityForDay = date => {
		const {
			setLoading,
			getActivityForDay,
			projectId
		} = this.props

		if(!setLoading || date.isSame(moment(), 'day')){
			return
		}

		setLoading(true)

		getActivityForDay(projectId, date.format('YYYY-MM-DD'), _ => {
			setLoading(false)
		})
	}

	loadMore = _ => {
		const {
			context,
			projectId,
			currentAccount,
			team,
			user,
			loadMore
		} = this.props

		let parentId = null

		switch(context){
			case 'project':
				parentId = projectId
				break
			case 'account':
				parentId = currentAccount.id
				break
			case 'team':
				parentId = team.id
				break
			case 'user':
				parentId = user.id
				break
		}

		loadMore(context, parentId, this.currentOffset, hasMore => {
			this.setState({
				hasMore
			})
		})
	}

	getProjectFromObject = (object, type) => {
		let project = null

		const {
			entities
		} = this.props

		const allProjects = entities.projects

		let task = null
		let milestone = null

		switch(type){
			case 'task':
				milestone = entities.milestones[object.milestone_id]

				if(milestone){
					project = allProjects[milestone.project_id]
				}
				break
			case 'note':
				project = allProjects[object.project_id]
				break
			case 'milestone':
				project = allProjects[object.project_id]
				break
			case 'comment':
				task = entities.tasks[object.task_id]

				if(task){
					milestone = entities.milestones[task.milestone_id]
					
					if(milestone){
						project = allProjects[milestone.project_id]
					}
				}
				break
			case 'project':
				project = object
				break
		}

		if(!project && object.project_id){
			project = allProjects[object.project_id]
		}

		return project
	}

	addMissingEntity = (type, id) => {
		if(this.missingEntitiesByType[type+'s'] && !this.missingEntitiesByType[type+'s'].includes(id)){
			this.missingEntitiesByType[type+'s'].push(id)
		}else{
			this.missingEntitiesByType[type+'s'] = [id]
		}
	}

	normaliseSeconds = seconds => {
		let measurement = ''

		if(seconds < 60){
			measurement = seconds+' seconds'
		}else if(seconds < 3600){
			const minutes = (Math.floor(seconds/60))

			measurement = minutes+' minutes'

			const remainingSeconds = seconds - (minutes * 60)

			if(remainingSeconds){
				measurement += ' and '+remainingSeconds+' seconds'
			}
		}else{
			const hours = Math.floor(seconds/3600)

			measurement = hours+' hours'

			const remainingMinutes = Math.round((seconds - (hours * 3600))/ 60)

			if(remainingMinutes){
				measurement += ' and '+remainingMinutes+' minutes'
			}
		}

		return measurement
	}

	render() {	
		const {
			entities,
			context,
			projectId,
			team,
			user,
			currentAccount,
			isPulse
		} = this.props

		let totalItemCount = 0

		let alertBannerTitle = "Nothing's happened just yet."
		let alertBannerCopy = '' 

		switch(context){
			case 'project':
				const project = entities.projects[projectId]

				if(project.activity_items_count){
					totalItemCount = project.activity_items_count
				}

				alertBannerCopy = "This'll update whenever anything happens in this project." 
				break
			case 'account':

				break
			case 'team':
				if(team.activity_items_count){
					totalItemCount = team.activity_items_count
				}

				alertBannerCopy = `This'll update whenever ${ team ? team.name : 'this team' } does anything.`
				break
			case 'user':
				alertBannerCopy = `This'll update whenever ${user.first_name} does anything.`
				break
		}

		if(isPulse){
			alertBannerTitle = "No activity for this day."
			alertBannerCopy = "Select another date to view its activity."
		}

		const {
			isFetching,
			activityListHeight,
			hasMore
		} = this.state

		let groupedActivityGroups = this.groupedActivityGroups
		let totalItems = this.totalItems

		groupedActivityGroups = doSort(groupedActivityGroups, 'date', 'date', true)

		// either the API has told us there's more, or we've got less than it says there is.
		const showLoadMore = hasMore || (totalItems < totalItemCount)

		let transitionContainerClassName = "activity-list-transition-container" 

		if(activityListHeight){
			transitionContainerClassName += ' visible'
		}

		return (
			<div className="activity-list-container">
				{
					groupedActivityGroups.length ?
						<React.Fragment>
							<div className="activity-list-line" />
							<div 
								className={transitionContainerClassName}
								ref={ref => this.activityRefs.outer = ref}
								style={{
									height: activityListHeight+'px'
								}}
							>
								<ul className="activity-list" ref={ref => this.activityRefs.inner = ref}>
									{
										groupedActivityGroups.map((activityGroup, i) => {
											return (
												<li className="clear" key={i}>
													<div className="activity-date">
														<div>
															<figure>
																{moment(activityGroup.date).format('DD')}
															</figure>
															<span>
																{moment(activityGroup.date).format('MMM')}
															</span>
														</div>
													</div>
													<hr />
													<div className="activity-content">
														<ul>
															{
																activityGroup.groupedActivities.map((groupedActivity, i) => {
																	if(groupedActivity.hidden){
																		return null
																	}

																	let activityUser = this.props.entities.users[groupedActivity.user_id]
																	let objectName // actually defined further down.
																	let entityId // only used for missing entities

																	const objectType = modelTypeToString(groupedActivity.type)
																	const isTimeTracking = objectType == 'session'

																	if (!activityUser) {
																		activityUser = {
																			first_name: 'A deleted user',
																			last_name: ' '
																		}
																	}

																	const firstActivityable = entities[groupedActivity.activities[0].activityable.schema][groupedActivity.activities[0].activityable.id]
																	const project = this.getProjectFromObject(firstActivityable, objectType)

																	if(!project){
																		console.log(groupedActivity.activities[0])
																		console.log(firstActivityable)
																		console.log(objectType)
																		console.log('no project!')
																		return null
																	}

																	if(!firstActivityable){
																		console.log('no activityable')
																		return null
																	}

																	let activityTitle = '<strong>' + activityUser.first_name + ' ' + activityUser.last_name + '</strong> '

																	// old scheme - didn't show from/to
																	if(!groupedActivity.data){
																		switch (groupedActivity.action) {
																			case 'CHANGE_STATUS':
																				activityTitle += 'changed the status of '
																				break
																			case 'CHANGE_STARTDATE':
																				activityTitle += 'changed the start date of '
																				break
																			case 'CHANGE_ENDDATE':
																				activityTitle += 'changed the end date of '
																				break
																			case "CHANGE_USERS":
																				activityTitle += 'changed the users on '
																				break
																			case 'CHANGE_DATES':
																				activityTitle += 'changed start & end dates on '
																				break
																			case 'CHANGE_TIME_ESTIMATE':
																				activityTitle += 'changed time estimates on '
																				break
																			case 'RENAME':
																				activityTitle += 'renamed '
																				break
																			case 'UPDATE':
																				activityTitle += 'updated '
																				break
																			case 'CREATE':
																				activityTitle += 'created '
																				break
																			case 'LIKE':
																				activityTitle += 'liked '
																				break
																			case 'POST':
																				activityTitle += 'posted '
																				break
																			case 'UPLOAD':
																				activityTitle += 'uploaded '
																				break
																			case 'UPLOAD_VERSION':
																				activityTitle += 'uploaded a new version of '
																				break
																			case 'CHANGE_DESCRIPTION':
																				activityTitle += 'changed the description of '
																				break
																			case 'STOP':
																				activityTitle += 'stopped '
																				break
																			case 'DELETE':
																				activityTitle += isTimeTracking ? 'deleted ' : 'archived '
																				break
																		}

																		if (groupedActivity.activities.length > 1) {
																			if(isTimeTracking){
																				activityTitle += 'time-tracking sessions on '+groupedActivity.activities.length+' tasks:'
																			}else{
																				activityTitle += groupedActivity.activities.length + ' ' + objectType + 's:'
																			}
																		} else {
																			if (groupedActivity.activities[0].activityable) {

																				objectName = this.getObjectName(firstActivityable, groupedActivity.activities[0].activityable.schema)

																				if(!objectName){
																					return null
																				}

																				if(isTimeTracking){
																					activityTitle += 'a time-tracking session on <strong>'+objectName+'</strong>'
																				}else{
																					activityTitle += '<strong>' +objectName+ '</strong>'
																				}
																			} else {
																				activityTitle += 'a since deleted ' + objectType + ''
																			}
																		}
																	}else{
																		objectName = this.getObjectName(firstActivityable, groupedActivity.activities[0].activityable.schema)

																		let dataEntity = null
																		let dataType = null

																		const numberOfItems = groupedActivity.activities.length

																		let data = null

																		switch(groupedActivity.action){
																			case 'RENAME':
																				activityTitle += `renamed <strong>${groupedActivity.oldData}</strong> to <strong>${groupedActivity.data}</strong>`
																				break
																			case 'CHANGE_STATUS':
																				let statusName = getStatusName(groupedActivity.data, project, entities.statuses)

																				activityTitle += `set ${ numberOfItems > 1 ? numberOfItems+' '+objectType+'s' : '<strong>'+objectName+'</strong>' } to <strong>'${statusName}'</strong>${ numberOfItems > 1 ? ':' : '' }`
																				break
																			case 'CHANGE_STARTDATE':
																				data = groupedActivity.data.includes('start') ? moment(JSON.parse(groupedActivity.data).start) : moment(groupedActivity.data)

																				activityTitle += `${ groupedActivity.oldData ? 'changed' : 'set'} the start date of ${ numberOfItems > 1 ? numberOfItems+' '+objectType+'s' : '<strong>'+objectName+'</strong>' } to <strong>${formatStandardDateTime(data, null, true, null, true)}</strong>${ numberOfItems > 1 ? ':' : '' }`
																				break
																			case 'CHANGE_ENDDATE':
																				data = groupedActivity.data.includes('end') ? moment(JSON.parse(groupedActivity.data).end) : moment(groupedActivity.data)

																				activityTitle += `${ groupedActivity.oldData ? 'changed' : 'set'} the end date of ${ numberOfItems > 1 ? numberOfItems+' '+objectType+'s' : '<strong>'+objectName+'</strong>' } to <strong>${formatStandardDateTime(data, null, true, null, true)}</strong>${ numberOfItems > 1 ? ':' : '' }`

																				break
																			case 'CHANGE_USERS':
																				const oldUsers = (groupedActivity.oldData && groupedActivity.oldData !== 'null') ? JSON.parse(groupedActivity.oldData) : []
																				const newUsers = (groupedActivity.data && groupedActivity.data !== 'null') ? JSON.parse(groupedActivity.data) : []

																				let affectedUserName = 'a deleted user'
																				let operation = null

																				if(oldUsers.length > newUsers.length){
																					operation = 'removed'
																					const removedUserId = oldUsers.find(oldUserId => {
																						return !newUsers.includes(oldUserId)
																					})

																					const removedUser = entities.users[removedUserId]

																					if(removedUser){
																						affectedUserName = removedUser.first_name+' '+removedUser.last_name
																					}

																				}else{
																					operation = 'added'
																					const addedUserId = newUsers.find(newUserId => {
																						return !oldUsers.includes(newUserId)
																					})

																					const addedUser = entities.users[addedUserId]

																					if(addedUser){
																						affectedUserName = addedUser.first_name+' '+addedUser.last_name
																					}

																				}

																				activityTitle += `${operation} <strong>${affectedUserName}</strong> ${ operation == 'added' ? 'to' : 'from'} ${ numberOfItems > 1 ? numberOfItems+' '+objectType+'s' : '<strong>'+objectName+'</strong>' }`
																				break
																			case "TEAM_ADDED_TO_PROJECT":
																				//const teamName = context == 'team' ? 'this team' : 
																				activityTitle += `added ${ this.getObjectName(groupedActivity.new_data, 'teams') } to <strong>${firstActivityable.name}</strong>`
																				break
																			case 'TEAM_REMOVED_FROM_PROJECT':
																				activityTitle += `removed ${ this.getObjectName(groupedActivity.new_data, 'teams') }  from <strong>${firstActivityable.name}</strong>`
																				break
																			case 'POST':
																				dataEntity = entities.tasks[groupedActivity.data]

																				if(!dataEntity || !dataEntity.name){
																					this.addMissingEntity(dataType, entityId)
																					return null
																				}

																				activityTitle += `posted ${ numberOfItems > 1 ? numberOfItems+' comments' : 'a comment' } to <strong>${dataEntity.name}</strong>${ numberOfItems > 1 ? ':' : ': "'+this.getObjectName(firstActivityable, 'comments')+'"' }`
																				break
																			case 'UPLOAD':
																				if(groupedActivity.data.includes('task')){
																					dataType = 'task'
																					entityId = parseInt(groupedActivity.data.replace('task_',''))
																					dataEntity = entities.tasks[entityId]	
																				}else{
																					dataType = 'project'
																					entityId = parseInt(groupedActivity.data.replace('project_',''))

																					dataEntity = entities.projects[entityId]
																				}

																				if(!dataEntity || !dataEntity.name){
																					this.addMissingEntity(dataType, entityId)
																					return null
																				}

																				activityTitle += `uploaded ${ numberOfItems > 1 ? numberOfItems+' files' : '<strong>'+this.getObjectName(firstActivityable, 'files')+'</strong>' } to the ${dataType} <strong>${ dataEntity.name }</strong>${ numberOfItems > 1 ? ':': '' }`

																				break
																			case 'STOP':
																				const secondsTracked = groupedActivity.data.includes('_') ? parseInt(groupedActivity.data.split('_')[1]) : parseInt(groupedActivity.data)

																				activityTitle += `tracked ${this.normaliseSeconds(secondsTracked)} on <strong>${objectName}</strong>`
																				break
																			case 'UPDATE':
																				switch(groupedActivity.type){
																					case 'App\\Session':
																						const differenceInSeconds = parseInt(groupedActivity.data) - parseInt(groupedActivity.oldData)

																						if(differenceInSeconds > 0){
																							activityTitle += ` added ${this.normaliseSeconds(differenceInSeconds)} to`
																						}else{
																							activityTitle += ` removed ${this.normaliseSeconds(Math.abs(differenceInSeconds))} from`
																						}

																						activityTitle += ' their time-tracking session on <strong>'+objectName+'</strong>'
																						break
																				}

																				break
																			case 'CHANGE_TIME_ESTIMATE':
																				const oldEstimate = parseInt(groupedActivity.oldData)
																				const newEstimate = parseInt(groupedActivity.data)

																				if(!oldEstimate && newEstimate){
																					activityTitle += ` added an estimate of <strong>${this.normaliseSeconds(newEstimate)}</strong> to <strong>${objectName}</strong>`
																				}else{
																					activityTitle += ` changed the time estimate on <strong>${objectName}</strong> from <strong>${this.normaliseSeconds(oldEstimate)}</strong> to <strong>${this.normaliseSeconds(newEstimate)}</strong>`
																				}
																				break
																		}

																	}

																	const timeString = formatByTimeZone(groupedActivity.activities[0].created_at,'h:mm a')

																	let subtitle = ''

																	if(groupedActivity.activities.length == 1){
																		subtitle += 'Type: '+ucfirst(objectType)+' '
																	}

																	if(context !== 'project' && project){
																		subtitle += `${groupedActivity.activities.length == 1 ? '• ' : ''}Project: `
																	}else if(isPulse){
																		subtitle += timeString
																	}

																	return (
																		<li className="clear" key={i}>
																			<span className="activity-content-time">
																				{ timeString }
																			</span>
																			<ProfilePicture 
																				user={activityUser} 
																				isTiny={true} 
																			/>
																			<div className="activity-content-text">
																				<span className="time mobile-only">
																					{ timeString }
																				</span>
																				<h3 dangerouslySetInnerHTML={{ __html: activityTitle }} />
																				<span className="disclaimer">
																					{ subtitle }
																					{ context !== 'project' && project ? 
																						<Link to={`/${currentAccount.slug}/projects/${project.slug}/tasks`}>
																							{ project.name}
																						</Link>
																						: null
																					}
																				</span>
																				{
																					groupedActivity.activities.length > 1 &&
																					<ul>
																						{
																							groupedActivity.activities.map(activity => {
																								if (activity.activityable) {
																									let activityable = entities[activity.activityable.schema][activity.activityable.id]

																									objectName = this.getObjectName(activityable, activity.activityable.schema)

																									return (
																										<li key={activity.id}>
																											{ objectName }
																										</li>
																									)
																								} else {
																									return null
																								}
																							})
																						}
																					</ul>
																				}
																			</div>
																		</li>
																	)
																})
															}
														</ul>
													</div>
												</li>
											)
										})
									}
								</ul>
							</div>
							<LoadMore
								isLoading={isFetching}
								canLoadMore={showLoadMore}
								onClick={_ => {this.loadMore(this.currentOffset)}}
								type="activity"
							/>
						</React.Fragment>
						:
						<AlertBanner 
							low={false} 
							title={alertBannerTitle} 
							body={alertBannerCopy} 
						/>
				}
			</div>
		)
	}
}

const mapStateToProps = state => {
	return {
		entities: state.account.entities,
		currentAccount: getCurrentAccount(state)
	}
}

export default connect(mapStateToProps, { 
	loadMore,
	getMissingEntities,
	getActivityForDay
})(ActivityList)
